import { SubjectManager } from "../utils/subject-manager";

export const interactiveSimulationsEventsService = new SubjectManager();
